module.exports = __webpack_public_path__ + "static/media/Conservationist.af34ebf6.jpg";